import React from 'react';
import PokerGameSessionHistory from '../../games/poker/PokerGameSessionHistory';

const PlayerGameSession = ({ playerID }) => {
    return <PokerGameSessionHistory forPlayer={true} playerID={playerID} />
};

export default PlayerGameSession;
